
import { getMinTotalDuration, getActualPeriodDuration, getPeriod, getMaxTotalDuration } from "./rules.js";

export const EMPTY_PLAYER = {lastname : 'Equipe', firstname : '', number : 0, numero : 0, empty : true}

export const getPlayerById = (id, match) => {
    // Le but ici est de récupérer 'numero' de la feuille de match
    const playerInFDM = allFeuilledematchPlayers(match).find(p => p._id === id) ?? {}

    const player = allPlayers(match).find(p => p._id === id)

    if(!player)
        return EMPTY_PLAYER

    return {...player, numero : playerInFDM.numero ? playerInFDM.numero : player.numero}
}

export const getTeamInfoById = (id, match) => [match.homeTeam, match.awayTeam].find(t => t && t._id === id) ?? {};

export const allPlayers = (match) => match.type!=='actu' ? [...match.homeTeam.players, ...match.awayTeam.players] : []

export const allFeuilledematchPlayers = (match) => match.type!=='actu' ? [...match.homeHolders, ...match.awayHolders, ...match.homeSubstitutes, ...match.awaySubstitutes] : []

export const homePlayers = (match) => match.homeTeam.players

export const awayPlayers = (match) => match.awayTeam.players

export const getPlayerNumber = (player) => {
    return player.numero || player.number
}

//TODO refactoring rules.js
export const getVisualTimer = (timer, period, discipline) => {
    if(['soccer', 'rugby'].includes(discipline)){
        // if(period === 2 || period === 6 || timer === 0)
        //     return ''
    
        if(period === 5)
            return 't.a.b'

    }

    if(['handball'].includes(discipline)){
        const periodObject = getPeriod(period, discipline)
        if(periodObject.periodPhase === 'so'){
            return 't.a.b'
        }
    }
    
    
    const minTotalDuration = getMinTotalDuration(period, discipline)
    const actualPeriodDuration = getActualPeriodDuration(period, discipline)

    const periodPlayedTimeAllowed =  Math.min(timer, actualPeriodDuration)
    const maxAllowedTimer = minTotalDuration + periodPlayedTimeAllowed
    const delta = timer - actualPeriodDuration

    let additionalTime = delta > 0 ? delta : null;

    
    return additionalTime ? maxAllowedTimer+"'(+"+additionalTime+")" : maxAllowedTimer+"'"
}

export const getNumericTimer = (timer, period, discipline) => {

    const minTotalDuration = getMinTotalDuration(period, discipline)

    return parseFloat(timer) + (minTotalDuration)
}

export const getMediaNumericTimer = (timer, period, discipline) => {

    const minutes = Math.floor(timer / 60);
    const seconds = timer % 60;
    
    const convertTimer = parseFloat(minutes+"."+seconds)

    const minTotalDuration = getMinTotalDuration(period, discipline)

    return convertTimer + (minTotalDuration) 
}